import { Grid, PaletteMode, SxProps } from '@mui/material';
import { FC, ReactNode } from 'react';
import { sxs } from '@utils/mui/sx';

const getSearchBoxStyles = (
    colorVersion: string,
    isDisable: boolean,
    expandable: boolean,
): SxProps => {
    let backgroundColor: string;
    let boxShadow: string | number;
    let opacity: number;
    let pointerEvents: string;

    if (isDisable) {
        backgroundColor = 'grey.300';
        boxShadow = 'none';
        opacity = 0.5;
        pointerEvents = 'none';
    } else {
        backgroundColor = colorVersion === 'dark' ? 'secondary.main' : 'background.default';
        boxShadow = 1;
        opacity = 1;
        pointerEvents = 'auto';
    }

    return {
        backgroundColor,
        border: 1,
        borderColor: colorVersion === 'dark' ? 'grey.300' : 'transparent',
        borderRadius: 0.5,
        boxShadow,
        height: expandable ? 'auto' : 56,
        minHeight: expandable ? 56 : 'auto',
        opacity,
        pointerEvents,
        position: 'relative',
        py: expandable ? 1 : 0,
    };
};

interface SearchBoxContainerProps {
    children: ReactNode;
    colorVersion?: PaletteMode;
    expandable?: boolean;
    isDisable?: boolean;
    sx?: SxProps;
}

const SearchBoxContainer: FC<SearchBoxContainerProps> = ({
    children,
    colorVersion = 'light',
    expandable = false,
    isDisable = false,
    sx = {},
}) => {
    const searchBoxStyles = getSearchBoxStyles(colorVersion, isDisable, expandable);

    return (
        <Grid
            alignContent="center"
            alignItems={expandable ? 'flex-end' : 'center'}
            direction="row"
            id="keep-underbar-card-open"
            sx={sxs([searchBoxStyles, sx])}
            container
        >
            {children}
        </Grid>
    );
};

export default SearchBoxContainer;
